/*
 * SashiDo
 * All rights reserved.
 */

import SashiDo from 'lib/SashiDo';

import DropDown from 'components/BoxFieldset/DropDown.react';
import types from 'components/BoxFieldset/Constants';
import Toolbar from 'components/Toolbar/Toolbar.react';
import Icon from 'components/Icon/Icon.react';
import React from 'react';
import EmptyState from 'components/EmptyState/EmptyState.react';
import FormModal from 'components/FormModal/FormModal.react';
import Field from 'components/Field/Field.react';
import Label from 'components/Label/Label.react';
import TextInput from 'components/TextInput/TextInput.react';
import Modal from 'components/Modal/Modal.react';
import modalStyles from 'components/Modal/Modal.scss';
import AccountManager from 'lib/AccountManager';
import history from 'dashboard/history';
import StatusIndicator from 'components/StatusIndicator/StatusIndicator.react';
import Fieldset from 'components/Fieldset/Fieldset.react';
import PreLoader from 'components/PreLoader/PreLoader.react';
import SashiDoTableView from 'dashboard/SashiDoTableView.react';
import settingsStyles from 'dashboard/Settings/Settings.scss';
import stylesButton from 'components/Button/Button.scss';
import Button from 'components/Button/Button.react';
import Notification from 'components/Notification/Notification.react';
import TeamDesk from 'components/TeamDesk/TeamDesk.react';
import * as formatter from 'lib/formatter';
import styles from './Backup.scss';
import { timeStampToUTC, dateStringUTC, isDate } from 'lib/DateUtils';

const BACKUP_STATUS_COLOR = {
  done: 'green',
  failed: 'red',
};

const BACKUP_STATUS_CONTENT = {
  done: 'SUCCESS',
  failed: 'FAILED',
};

export default class DownloadHistory extends SashiDoTableView {
  constructor() {
    super();

    this.section = 'Automatic Database Backups';
    this.subsection = 'Download History';

    this.state = {
      loading: true,
      data: [],
      progress: false,
      password: '',
      showActivateBackupsModal: false,
      note: {},
      isTeamDeskOpen: false,
    };
  }

  componentDidMount() {
    SashiDo.getAppDBDownloadList({ id: this.context.currentApp.id }).then((data) => {
      this.setState({
        loading: false,
        data,
      });
    });

    if (!this.context.currentApp.params.backups_enabled && this.context.currentApp.params.backups_enabled_from) {
      this.setState({ showAfterDeactivateMessage: true });
    }
  }

  activateBackups() {
    this.setState({ showActivateBackupsModal: true });
  }

  handleTeamDeskOpen() {
    this.setState({ isTeamDeskOpen: true });
  }

  goToBackupsActivationPage() {
    history.push({
      pathname: '/backups',
      state: { activate: true },
    });
  }

  navigateToAddCard() {
    history.push('billing/add_card');
  }


  renderToolbar(data) {
    return (
      <Toolbar
        section={this.section}
        subsection={this.subsection}>
        <DropDown items={types.apps__backups} type="toolbar" />
        {
          // !this.context.currentApp.params.backups_enabled && this.context.currentApp.params.backups_enabled_from &&
          //   <Button color='green' value='Activate Automatic Backups' onClick={this.activateBackups.bind(this)} />
        }
        {/*
        this.context.currentApp.params.backups_enabled
        ? <Button color='blue' progress={this.state.progress} value='Create backup' onClick={this.createBackup.bind(this)} />
        : null
        */}
      </Toolbar>
    );
  }

  renderHeaders() {
    const headers = [
      <colgroup key={`${this.props.params.section}_colgroup`}>
        <col width="40%" />
        <col width="30%" />
        <col width="20%" />
        <col width="10%" />
      </colgroup>,
      <thead key={`${this.props.params.section}_thead`}>
        <tr>
          <th>Downloaded on</th>
          <th>Backup from</th>
          <th>User</th>
        </tr>
      </thead>,
    ];
    return headers;
  }

  renderEmpty() {
    if (!this.props.currentUser || !this.props.currentUser.email) return;

    const isCollaborator = this.props.currentUser.id !== this.context.currentApp.user.objectId;

    if (isCollaborator) {
      return (
        <EmptyState
          maxWidth={600}
          title="This app does not have active Automatic Database Backups."
          description="Please contact the app owner to activate the backups through their Account." />
      );
    }

    if (this.props.currentUser.backups_enabled) {
      if (this.state.data.length === 0) {
        return (
          <EmptyState
            maxWidth={600}
            title="You haven't downloaded any Database Backups yet" />
        );
      }
    } else {
      if (this.props.currentCustomer.is_trial) {
        if (this.state.currentCustomer.card && this.state.currentCustomer.card.status == 'valid') {
          return (
            <EmptyState
              title="Automatic Database Backups can be activated only after your first billing cycle"
              description="Need Database Backups sooner?"
              cta="Contact Support"
              action={this.handleTeamDeskOpen.bind(this)} />
          );
        }
        return (
          <EmptyState
            title="Automatic Database Backups can be activated only after your first billing cycle"
            description="Add your credit card to manage your apps without interruption."
            cta="Add Credit Card"
            action={this.navigateToAddCard.bind(this)} />
        );
      }
      return (
        <EmptyState
          title="Activate Automatic Database Backups for all of your apps!"
          smallTitle
          descriptionWithHTML="The service comes at <strong>$15 per account monthly</strong>."
          cta="Activate Automatic Backups"
          action={this.goToBackupsActivationPage.bind(this)} />
      );
    }
  }

  renderEmpty() {
    if (!this.props.currentUser || !this.props.currentUser.email) return;

    const isOwner = this.props.currentUser.email === this.context.currentApp.params.owner;

    if (this.props.currentCustomer.is_trial) {
      if (this.state.currentCustomer.card && this.state.currentCustomer.card.status == 'valid') {
        return (
          <EmptyState
            title="Automatic Database Backups can be activated only after your first billing cycle"
            description="Need Database Backups sooner?"
            cta="Contact Support"
            action={this.handleTeamDeskOpen.bind(this)} />
        );
      }
      return (
        <EmptyState
          title="Automatic Database Backups can be activated only after your first billing cycle"
          description="Add your credit card to manage your apps without interruption."
          cta="Add Credit Card"
          action={this.navigateToAddCard.bind(this)} />
      );
    }

    if (isOwner && !this.context.currentApp.params.backups_enabled) {
      return (
        <EmptyState
          title="Activate Automatic Database Backups for all of your apps!"
          smallTitle
          descriptionWithHTML="The service comes at <strong>$15 per account monthly</strong>"
          cta="Activate Automatic Backups"
          action={this.goToBackupsActivationPage.bind(this)} />
      );
    }

    if (this.state.data.length === 0) {
      return (
        <EmptyState
          maxWidth={600}
          title="You haven't downloaded any Database Backups yet" />
      );
    }
  }

  renderModals() {
    const modals = [];

    modals.push(
      <Notification note={this.state.note} close />,
    );

    modals.push(
      <FormModal
        title="Activate Automatic Database Backups"
        type={Modal.Types.INFO}
        open={this.state.showActivateBackupsModal}
        submitText="Activate for $15/mo"
        inProgressText={'Activating\u2026'}
        enabled={this.state.password.length > 0}
        onSubmit={() => this.context.currentApp.setBackupsState(true, this.state.password).then(() => {
          this.setState({
            showAfterDeactivateMessage: false,
            note: {
              type: 'success',
              message: 'Automatic Database Backups were successfully activated.',
            },
          });
        })}
        onClose={() => this.setState({ showActivateBackupsModal: false })}
        clearFields={() => this.setState({ password: '' })}>

        <p className={modalStyles.only}>I am aware that this is an extra service which costs <strong>$15</strong></p>

        <div className={modalStyles.hr} />

        <Field
          labelWidth={60}
          label={<Label text="Your password" />}
          input={<TextInput
            hidden
            value={this.state.password}
            placeholder="Password"
            onChange={(newValue) => { this.setState({ password: newValue }); }} />} />
      </FormModal>,
    );

    modals.push(<TeamDesk open={this.state.isTeamDeskOpen} />);

    return modals;
  }

  renderRow(data) {
    let name = '';

    let users;

    if (this.props.initialFields) {
      users = this.props.initialFields.collaborators.map(({ objectId, username }) => {
        return {
          objectId,
          username,
        };
      });
    }

    if (users) {
      users.forEach((user) => {
        if (user.objectId === data.user.objectId) {
          name = user.username;
        }
      });
    }

    const classes = [stylesButton.tableButton, stylesButton.blue];

    // if(!data.success || data.status != 'done') {
    //   classes.push(stylesButton.disabled);
    // }

    // <a
    //   className={classes.join(' ')}
    //   href='javascript:;'
    //   onClick={() => this.downloadBackup(data.id, data.success, data.status)}>
    //   Download
    // </a>

    return (
      <tr key={`${data.createdAt}${data.backup.created_at}`}>
        <td>{dateStringUTC(new Date(data.createdAt))}</td>
        <td>{dateStringUTC(new Date(data.backup.created_at))}</td>
        <td>{name}</td>
      </tr>
    );
  }

  tableData() {
    return this.state.showAfterDeactivateMessage ? [] : this.state.data;
  }
}
